export default "/images/tags.png?87b97ccbfc4d0e97ba796a59068a8ec9";